import classnames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { render, unmountComponentAtNode } from "react-dom";
import "./index.scss";

interface IProps {
  type: "success" | "error" | "info" | "warning";
  content: React.ReactNode;
  closeTime?: number;
}

function getRoot() {
  let root: Element;
  if (document.body.querySelector(".message__box")) {
    root = document.body.querySelector(".message__box") as Element;
  } else {
    root = document.createElement("div");
    root.className = "message__box";
    document.body.appendChild(root);
  }
  return root;
}

let onCloseHandler: () => void;

const Message: React.FC<IProps> = ({ type, content, closeTime = 2000 }) => {
  const myRef = useRef<HTMLDivElement>(null);
  const [hide, setHide] = useState(false);
  onCloseHandler = () => {
    if (myRef.current && myRef.current.parentElement) {
      const root = getRoot();
      const parentElement = myRef.current.parentElement;
      setHide(true);

      setTimeout(() => {
        root.removeChild(parentElement);
        unmountComponentAtNode(parentElement);

        if (root.childNodes.length === 0) {
          window.document.body.removeChild(root);
        }
      }, 1000);
    }
  };

  useEffect(() => {
    setTimeout(onCloseHandler, closeTime);
  }, [closeTime]);

  const mergeClassName = classnames("message", `message--${type}`, {
    "message--hide": hide,
  });

  return (
    <div className={mergeClassName} ref={myRef}>
      <i className="message__icon" />
      <div className="message__content">{content}</div>
    </div>
  );
};

function getComponent({ ...props }: IProps) {
  const root = getRoot();
  const container = document.createElement("div");
  root.appendChild(container);

  render(<Message {...props} />, container);
}

export const message = {
  show({ ...props }: IProps) {
    return getComponent(props);
  },
  close() {
    onCloseHandler && onCloseHandler();
  },
};
